import moment from "moment";
import { Fragment } from "react";
import Clock from "../../../../assets/Clock";
import Settings from "../../../../assets/Settings";
import Typography from "../../../../common/Typography";
import { getFullImageUrl } from "../../../../../utils/constants/constants";

const NegFbActionTerms = ({
  storeDetails,
  lastTxnDate,
  rewardDetails,
  loyaltyDetails,
}) => {
  const { logo: storeLogo, name: storeName } = storeDetails;
  const points_expiry = loyaltyDetails?.settings?.points_expiry;
  const expiryDate = getExpiryDate(rewardDetails, lastTxnDate, points_expiry);
  const items = [
    {
      key: "terms-conditions",
      heading: "Terms & Conditions",
      icon: <Settings color="#697777" />,
      points: rewardDetails?.terms?.length > 0 ? [...rewardDetails.terms] : [],
    },
    {
      key: "expiry",
      heading: "Expiry",
      icon: <Clock height={18} width={18} color={"#697777"} />,
      points: [expiryDate],
    },
  ];

  return (
    <div className="neg-fb-action-terms">
      <div className="store-details">
        {getFullImageUrl(storeLogo)?.length > 0 ? (
          <>
            <div className="store-logo">
              <img src={getFullImageUrl(storeLogo)} alt="logo" />
            </div>
            <Typography size="display-md" weight="medium">
              {storeName}
            </Typography>
          </>
        ) : (
          <div className="store-logo">
            <Typography size="text-xs" weight="medium" customClass="store-name">
              {storeName}
            </Typography>
          </div>
        )}
      </div>
      <div className="items">
        {items?.map((item) =>
          item.key === "expiry" && !expiryDate ? (
            <></>
          ) : (
            <Fragment key={item.key}>
              <div className={item.key}>
                <div className="heading">
                  {item.icon}
                  <Typography size="text-md" weight="medium">
                    {item.heading}
                  </Typography>
                </div>
                <ul className="points">
                  {item.points?.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </div>
              {item.key === "terms-conditions" && expiryDate && (
                <div className="divider" />
              )}
            </Fragment>
          )
        )}
      </div>
    </div>
  );
};

const getExpiryDate = (rewardDetails, last_transaction_date, points_expiry) => {
  const isInactiveBonusPointsExpiry =
    rewardDetails?.reward_type === "bonus_points" && !points_expiry?.active;
  if (
    !last_transaction_date ||
    isInactiveBonusPointsExpiry ||
    rewardDetails?.reward_type === "no_discount"
  )
    return null;

  let period = "";
  let duration = "";

  if (rewardDetails?.reward_type === "bonus_points") {
    period = "months";
    duration = points_expiry.current;
  } else {
    period = rewardDetails?.expiry?.period || 0;
    duration = rewardDetails?.expiry?.duration || "days";
  }

  const expiryDate = moment(last_transaction_date).add(duration, period);
  return expiryDate.format("Do MMM, YYYY");
};

export default NegFbActionTerms;
